import { TextField, Select } from '@cinesend/ui-kit'
import React, { useState } from 'react'
import useStore from '../../../hooks/use_store'

const AirlineValidatorParams = ({ name, data }) => {
  const [value, setValue] = useState(data.parameters?.value)
  const { createModel } = useStore()

  if (!data.parameters || typeof data.parameters != 'object' || Object.keys(data.parameters).length === 0) {
    return ''
  }

  const saveParamsValue = (value) => {
    createModel.mutate({
      endpoint: 'validator-airline-config',
      data: {
        validator_id: data.validator_id,
        airline_id: data.airline_id,
        parameters: {
          options: data.parameters.options,
          value: value,
        },
      },
    })
  }

  // for list return dropdown
  if (data.parameters?.options) {
    return (
      <Select
        fullWidth
        label={name}
        hideLabel
        options={data.parameters.options.map((item) => ({ ...item, value: String(item.value) }))}
        value={value == null ? null : String(value)}
        onValueChange={(selected) => {
          const { value: optionValue } = data.parameters.options.find((item) => String(item.value) === selected)
          setValue(optionValue)
          saveParamsValue(optionValue)
        }}
      />
    )
  }

  return (
    <TextField
      name={name}
      label={name}
      hideLabel
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => saveParamsValue(value)}
    />
  )
}

export default AirlineValidatorParams
